/**
 * Footer component
 * ----------------
 */

/* Imports */

import React from "react";
import { Footer, FooterRow } from "./styles.module.scss";
import Social from "../Social";

/* Variables */

const socials = [
  {
    title: "TikTok",
    link: "https://www.tiktok.com/@later.com/",
  },
  {
    title: "Instagram",
    link: "https://instagram.com/latermedia/",
  },
  {
    title: "Facebook",
    link: "https://www.facebook.com/latermedia/",
  },
  {
    title: "Twitter",
    link: "https://twitter.com/latermedia/",
  },
  {
    title: "Pinterest",
    link: "https://www.pinterest.com/latermedia/",
  },
];

/* Component */

const FooterComponent = () => {
  return (
    <footer className={Footer}>
      <div className="lc-o-h">
        <div
          className="lc-container lc-pad-v lc-p-r lc-z-1 lc-move-fade-y lc-vis"
          data-size="xxs"
        >
          <div
            className={`${FooterRow} lc-flex`}
            data-align="center"
            data-justify="def"
            data-gap="r"
            data-mobile
            data-wrap
          >
            <div>
              <span className="lc-ff-display lc-tx-s lc-brown lc-links">
                A social media conference by{" "}
                <a className="lc-brown" href="https://later.com/">
                  Later
                </a>
              </span>
            </div>
            <div>
              <div className="lc-v-h">Follow us on:</div>
              <div className="lc-flex" data-align="center" data-gap="xs">
                {socials.map((s, i) => (
                  <Social key={`s-${i}`} title={s.title} link={s.link} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

/* Export */

export default FooterComponent;
